import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { TimelineMedicationRequestHomeMedIcon } from '../../../Icons';

interface Props {
  item: any;
}
const MedicationRequestHomeItem = ({ item }: Props) => {
  return (
    <ItemWithTooltip item={item}>
      <TimelineMedicationRequestHomeMedIcon />
    </ItemWithTooltip>
  );
};

export default MedicationRequestHomeItem;
